<template>
  <fieldset>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Pixel ID *</div>
      </div>
      <input type="text" class="form-control" required v-model="pixelId" @input="onUpdate">
    </div>
  </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const pixelId = ref(null);
const serializedValue = computed(() => {
  return {
    pixel_id: pixelId.value
  };
});
function onUpdate() {
  emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    pixelId.value = modelValue.value.pixel_id;
  }
}, {
  immediate: true
});
</script>
